import { useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "translation/useTranslation";

export default function GroupBudgetAnalysis() {
  const { translate, editableTranslate } = useTranslation();

  const { overlay } = useOutletContext();

  return (
    <>
      <div className="col-lg col-md-9 section-col-right d-flex">
        <div className={`bg-white w-100 p-4 content-card`}>
          <h4>{editableTranslate('global.menu.evaluation_statistics.group_budget_analysis')}</h4>
          <p className="section-description">{editableTranslate('evaluation_statistics.group_budget_analysis_description')}</p>

          {overlay}
        </div>
      </div>
    </>
  );
}
